import axios from 'axios'

axios.defaults.withCredentials = true;

const useFetchData = axios.create({
  baseURL: process.env.NODE_ENV === 'development' 
    ? '/api' // Usa proxy em desenvolvimento
    : process.env.VUE_APP_API_URL || 'https://api.jobifull.com.br/swagger/api', // URL direta em produção
  headers: { 
    "Content-Type": "application/json",
    "accept": "application/json",
  },
  withCredentials: true,
});

export default useFetchData;